import React, {CSSProperties} from 'react';

import './../progressBar.scss'

interface IProgressBarLayoutProps {
    progress: string
    title?: string
    disableTitle?: boolean
    width?: string
    height?: string
    background?: string
    className?: string
    showProgress?: boolean
    style?: CSSProperties
}

const ProgressBarComponentLayout: React.FC<IProgressBarLayoutProps> = ({ progress, title, disableTitle, width, height, background, className, style, ...rest }) => {

    // Validaciones
    if (disableTitle === null || disableTitle === undefined) disableTitle = false;
    if (width === null || width === undefined) width = "100%";
    if (background === null || background === undefined) background = "-webkit-linear-gradient(left, rgba(147, 195, 240, 1) 0%, rgba(9, 79, 153, 1) 100%)";

    return (
        <div className={`progress_bar-component ${className}`} style={style}>
            {!disableTitle || rest.showProgress ?
              <div className="header-progress-bar">
                {disableTitle ? null : (<p className="title-percent">{title}</p>)}
                {rest.showProgress ? (<p className="text-percent">{progress}</p>) : null}
              </div>
            :null}
            <div style={{width: width, height: height}} className="container-progress">
                <div className="container-progress-2">
                    <div style={{width: progress, background: background}} className="progress-bar">
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgressBarComponentLayout;
